import { Card } from "@mui/material";
import { Box, styled } from "@mui/system";
// import { useTranslation } from "react-i18next";
// import { Trans, withTranslation } from "react-i18next";
// import { isMobile } from "react-device-detect";
import {
  colorTags,
  primaryColor,
  secondaryColor,
  accentColor,
} from "../constants/variants";

const CardRoot = styled(Card)(() => ({
  height: "100%",
  padding: "20px 24px",
  marginTop: "0%",
  boxShadow:
    "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
}));

const CardTitle = styled("div")(({ subtitle }) => ({
  fontSize: "1.2rem",
  marginLeft: "43%",
  fontWeight: "700",
  textTransform: "capitalize",
  marginBottom: !subtitle && "16px",
}));

const SimpleCard = ({ children, title, subtitle, icon }) => {
  // const { t, i18n } = useTranslation();

  // if (isMobile)
  //   return (
  //     <CardRoot elevation={6}>
  //       <CardTitle subtitle={subtitle} style={{ marginLeft: "25%" }}>
  //         {title}
  //       </CardTitle>
  //       {subtitle && <Box sx={{ mb: 2 }}>{subtitle}</Box>}
  //       {children}
  //     </CardRoot>
  //   );
  // else
  return (
    <CardRoot elevation={6}>
      <CardTitle subtitle={subtitle} style={{ color: colorTags.PRIMARY }}>
        {title}
      </CardTitle>
      {subtitle && <Box sx={{ mb: 2 }}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
};

export default SimpleCard;
